import './redraven/style';
import FormStructure from './redraven/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/Dev/web_inquiry/inquiry-renderer/client_forms/includes.js